export default __webpack_public_path__ + "static/media/person_1@2x.d24d57d3.png";